import React, { useState, useEffect } from 'react';
import { Save, Instagram, Facebook, Youtube, Linkedin, Twitter, Music2, MessageCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useToast } from '../../hooks/use-toast';
import adminApi from '../../lib/adminApi';

const FIELDS = [
  { key: 'instagram', label: 'Instagram', icon: Instagram, placeholder: 'https://www.instagram.com/partyled.official', hint: 'instagram.com → Créer un compte → nom suggéré : partyled.official' },
  { key: 'tiktok', label: 'TikTok', icon: Music2, placeholder: 'https://www.tiktok.com/@partyled.official', hint: 'tiktok.com → S\'inscrire → nom suggéré : @partyled.official' },
  { key: 'facebook', label: 'Facebook (Page)', icon: Facebook, placeholder: 'https://www.facebook.com/partyled.official', hint: 'facebook.com/pages/create → Page Entreprise' },
  { key: 'youtube', label: 'YouTube', icon: Youtube, placeholder: 'https://www.youtube.com/@partyled', hint: 'youtube.com → Créer une chaîne' },
  { key: 'linkedin', label: 'LinkedIn (Page)', icon: Linkedin, placeholder: 'https://www.linkedin.com/company/party-led', hint: 'linkedin.com/company/setup/new' },
  { key: 'x', label: 'X (Twitter)', icon: Twitter, placeholder: 'https://x.com/partyled', hint: 'x.com → S\'inscrire' },
  { key: 'whatsapp', label: 'WhatsApp Business', icon: MessageCircle, placeholder: 'https://wa.me/33491481213', hint: 'Format : https://wa.me/ + numéro sans + ni espaces' },
];

const EMPTY = { instagram: '', tiktok: '', facebook: '', youtube: '', linkedin: '', x: '', whatsapp: '' };

const SocialSettings = () => {
  const { toast } = useToast();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi
      .get('/api/admin/settings/social')
      .then((res) => setForm({ ...EMPTY, ...res.data }))
      .catch(() => setForm(EMPTY));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminApi.put('/api/admin/settings/social', form);
      toast({ title: 'Réseaux sociaux enregistrés', description: 'Les liens apparaissent immédiatement en bas du site.' });
    } catch (err) {
      toast({ title: 'Erreur', description: err.response?.data?.detail || '', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-social-settings">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white">Réseaux sociaux</h1>
        <p className="text-gray-400 text-sm mt-1">
          Collez ici l'adresse de chaque compte. Les icônes vides sont automatiquement masquées sur le site.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="bg-gray-900 border border-gray-800 rounded-xl p-6 space-y-5 max-w-3xl">
        {FIELDS.map(({ key, label, icon: Icon, placeholder, hint }) => (
          <div key={key}>
            <Label className="text-gray-300 flex items-center gap-2">
              <Icon className="w-4 h-4 text-orange-500" />
              {label}
            </Label>
            <Input
              value={form[key]}
              onChange={(e) => setForm({ ...form, [key]: e.target.value })}
              placeholder={placeholder}
              className="mt-1.5 bg-gray-800 border-gray-700 text-white"
              data-testid={`social-${key}`}
            />
            <p className="text-gray-500 text-xs mt-1.5">{hint}</p>
          </div>
        ))}

        <Button type="submit" disabled={saving} className="bg-orange-600 hover:bg-orange-500" data-testid="social-save">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </form>
    </div>
  );
};

export default SocialSettings;
